import { render, staticRenderFns } from "./help-hero-composer.vue?vue&type=template&id=7432116c&scoped=true"
import script from "./help-hero-composer.vue?vue&type=script&lang=js"
export * from "./help-hero-composer.vue?vue&type=script&lang=js"
import style0 from "./help-hero-composer.vue?vue&type=style&index=0&id=7432116c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432116c",
  null
  
)

export default component.exports